import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InventoryRoutingModule } from './inventory-routing.module';
import { InventoryComponent } from './inventory.component';
import { DataTablesModule } from 'angular-datatables';
import { AddVehicleComponent } from './add-vehicle/add-vehicle.component';
import { AddBatchComponent } from './add-batch/add-batch.component';
import { InventoryMainComponent } from './inventory-main/inventory-main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { BatchDetailsComponent } from './batch-details/batch-details.component';
import { ComponentsModule } from '@components/components.module';

import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { LoaderComponent } from '@components/loader/loader/loader.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { LaddaModule } from 'angular2-ladda';
import { RetailsComponent } from './retails/retails.component';
import { PurchaseComponent } from './purchase/purchase.component';
import { NewComponent } from './new/new.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { OverlayModule } from '@angular/cdk/overlay';

import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    InventoryComponent,
    AddVehicleComponent,
    AddBatchComponent,
    InventoryMainComponent,
    VehicleDetailsComponent,
    BatchDetailsComponent,
    RetailsComponent,
    PurchaseComponent,
    NewComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InventoryRoutingModule,
    ComponentsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatToolbarModule,

    DataTablesModule,
    NgDynamicBreadcrumbModule,
    TabsModule.forRoot(),
    SweetAlert2Module.forRoot(),
    TypeaheadModule.forRoot(),
    LaddaModule.forRoot({
      style: 'zoom-out',
      spinnerSize: 40,
      spinnerColor: '#F9B22C',
      spinnerLines: 12,
    }),
    ModalModule.forRoot(),
    MatAutocompleteModule,
    OverlayModule,
  ],
  // exports: [
  //   InventoryComponent,
  //   InventoryMainComponent,
  //   AddVehicleComponent,
  //   AddBatchComponent,
  //   VehicleDetailsComponent,
  //   BatchDetailsComponent,
  // ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InventoryModule {}
